import createSagaMiddleware from "redux-saga";

export const sagaMiddleware = createSagaMiddleware();

export function execute(saga, ...args) {
    return sagaMiddleware.run(saga, ...args).done;
}